import { LINK_TITLE, BUTTON_SETTINGS } from '../elements/link'
import { BACKGROUND_ASSET_MOBILE, BACKGROUND_ASSET_DESKTOP } from '../elements/assets'

export const HERO_SEASONS_EVENTS = `
...on heroSeasonsEvents_Entry {
  id
  typeHandle

  preheading
  headingSeasonsEvents {
    html
  }
  
  description

  ${ LINK_TITLE }
  ${ BUTTON_SETTINGS }

  ${ BACKGROUND_ASSET_MOBILE }
  ${ BACKGROUND_ASSET_DESKTOP }

}
`